// Lazy load React only when React components are needed
export const loadReact = async () => {
  try {
    const [React, ReactDOM] = await Promise.all([import('react'), import('react-dom/client')])

    const ReactNS = React.default || React
    const ReactDOMNS = ReactDOM.default || ReactDOM

    return { React: ReactNS, ReactDOM: ReactDOMNS }
  } catch (error) {
    console.error('loadReact failed:', error)
    throw error
  }
}
